export default "__VITE_ASSET__DWA5jfP4__"